import {
  SF_ACCOUNT_FOR_DEAL_FETCHED
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: {},
  error: null
}

//accounts are fetched as needed for deals
export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case SF_ACCOUNT_FOR_DEAL_FETCHED:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload._id]: action.payload,
        },
        error: null,
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/accountsReducer.js